import styled from 'styled-components/macro';

export const PraiseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PraiseHeader = styled.h4`
font-family: Caveat;
color: #257ca3;
font-size: 1.6rem;
`

export const PraiseTxt = styled.p`
font-family: Urbanist;
font-weight: 500;
margin: 0;
text-align: center;
`